var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMernverseLogoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 210.001,
    height: 43.104,
    viewBox: "0 0 210.001 43.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1301",
    "data-name": "Group 1301",
    transform: "translate(-84.999 -53.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_green",
    transform: "translate(-306.535 -336.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M443.19,562.722,417.353,577a1.673,1.673,0,0,1-1.678-.034l-22.747-13.8a.837.837,0,0,1,.028-1.448l1.568-.865a.82.82,0,0,1,.822.017l3.5,2.126,2.663,1.614a.82.82,0,0,0,.82.015l4.948-2.734a.817.817,0,0,1,.82.017l7.566,4.582.017.011a.817.817,0,0,0,.82.017l.017-.011,10.751-5.941a.823.823,0,0,1,.8,0l6.066,3.477a.819.819,0,0,0,.8,0l2.381-1.314,3.885-2.146a.816.816,0,0,1,.8,0l1.189.68a.819.819,0,0,1-.011,1.449Z",
    transform: "translate(-0.839 -144.62)",
    fill: "#0da34e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M442.515,505.2a.82.82,0,0,1-.011,1.428l-1.867,1.035-.876.483-3.838,2.122-1.957,1.079a.819.819,0,0,1-.8,0l-5.6-3.209-.867-.5-8.224-4.712-.014-.009a.822.822,0,0,0-.8,0l-.015.009-10.908,6.027-.86.47-4.5,2.488a.82.82,0,0,1-.816-.022l-2.239-1.361-3.5-2.114-.84-.509-2.035-1.233a.836.836,0,0,1,.028-1.446l1.337-.737a.82.82,0,0,1,.822.015l2.863,1.739h0l.839.509.034.02,2.661,1.614a.82.82,0,0,0,.822.017l1.485-.822.86-.475L417.64,499.4a.816.816,0,0,1,.8,0l11.366,6.511.865.5,2.476,1.418a.816.816,0,0,0,.8,0l2.381-1.314.3-.165.874-.483,2.741-1.516a.818.818,0,0,1,.8,0Z",
    transform: "translate(0 -92.875)",
    fill: "#0da34e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M442.52,474.929a.82.82,0,0,1-.011,1.428l-1.85,1.021-.873.48-3.144,1.739-.722.4-.154.086-1.8.994a.816.816,0,0,1-.8,0l-1.611-.925-.867-.495-12.208-7-.015-.009a.82.82,0,0,0-.8-.009l-.018.009-14.783,8.172-.862.476-.624.35a.817.817,0,0,1-.82-.017L398.7,480.5l-.384-.234-.455-.274-3.272-1.983-.839-.509-1.805-1.1a.837.837,0,0,1,.029-1.448L394,473.83a.817.817,0,0,1,.82.017l2.63,1.594.839.509.2.122,2.57,1.562a.82.82,0,0,0,.822.017l15.791-8.728a.819.819,0,0,1,.8,0l14.25,8.162a.819.819,0,0,0,.8,0l2.3-1.267.216-.12.873-.483,2.715-1.5a.819.819,0,0,1,.8,0Z",
    transform: "translate(-0.005 -67.097)",
    fill: "#0da34e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M446.032,403a.819.819,0,0,1-.011,1.428l-1.711.947-.871.48-3.125,1.724-.648.359-.225.125-1.664.925a.823.823,0,0,1-.8,0l-14.237-8.169h0a.819.819,0,0,0-.809,0h0l-15.781,8.71a.823.823,0,0,1-.822-.017l-1.957-1.189-.205-.125-.634-.384-3.036-1.839-.839-.509-1.631-.99a.837.837,0,0,1,.029-1.448l24.13-13.335a1.676,1.676,0,0,1,1.641.012Z",
    transform: "translate(-4.302)",
    fill: "#0da34e"
  })), /*#__PURE__*/React.createElement("text", {
    id: "MernVerse",
    transform: "translate(222 85)",
    fill: "#0e011b",
    fontSize: 28,
    fontFamily: "NeueHaasDisplay-Bold, Neue Haas Grotesk Display Pro",
    fontWeight: 700,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -72.786,
    y: 0
  }, "MERNverse")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMernverseLogoBlack);
export default __webpack_public_path__ + "static/media/mernverse-logo-black.c0dbc2da491c8e2a5622ffae6eb0e363.svg";
export { ForwardRef as ReactComponent };